import React, { lazy, Suspense } from "react";
import BounceLoading from "../components/BounceLoading";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import MainLayout from "../layout/MainLayout";
import ForgetPassLayout from "../pages/forgetPass/ForgetPassLayout";
import FormLetter from "../pages/prepareLetter/form-letter";
import LetterLayout from "../pages/prepareLetter/leter-layout";
import GuarantesLayout from "../pages/guarantes/GuarantesLayout";
import BankHubLayout from "../layout/BankHubLayout";
import Auth from "../layout/Auth";
import AuthDMG from "../layout/AuthDMG";


const LandingPage = lazy(() => import('../pages/landingPage/Home'))
const SignUpAccount = lazy(() => import('../pages/signup/SignupAccount'))
const ViewPdf = lazy(() => import('../pages/ViewPdf'))
const Guarantes = lazy(() => import('../pages/guarantes/index'))
const MisaLogin = lazy(() => import('../pages/signup/misa/LoginMisa'))
const ConfirmPayment = lazy(() => import('../pages/payment/misa/Confirm'))
const ConfirmDMG = lazy(() => import('../pages/payment/dmg/Confirm'))
const MainRoutes = (props) => {

    return (
        <Suspense
            fallback={
                <BounceLoading
                    style={{ marginLeft: '48vw', marginTop: '40vh' }}
                />
            }
        >
            <BrowserRouter basename='/dn'>
                <Routes >
                    <Route
                        exact
                        path="/ib"
                        element={<LandingPage
                            language={props.language}
                            onChangeLanguage={props.onChangeLanguage}
                        />}
                    />

                    <Route path="/dang-ky-ib" element={
                        <MainLayout language={props.language} onChangeLanguage={props.onChangeLanguage}>
                            <SignUpAccount />
                        </MainLayout>
                    } />
                    <Route path="/view-pdf" element={
                        <MainLayout language={props.language} onChangeLanguage={props.onChangeLanguage}>
                            <ViewPdf />
                        </MainLayout>
                    } />
                    <Route path="/quen-mat-khau" element={
                        <MainLayout language={props.language} onChangeLanguage={props.onChangeLanguage}>
                            <ForgetPassLayout onChangeLanguage={props.onChangeLanguage} state={{ state: 'mystate' }} />
                        </MainLayout>
                    } />
                    <Route path="/tracuubaolanh" element={
                        <GuarantesLayout language={props.language} onChangeLanguage={props.onChangeLanguage}>
                            <Guarantes />
                        </GuarantesLayout>
                    } />

                    <Route path="/soanthubaolanh" element={
                        <LetterLayout>
                            <FormLetter />
                        </LetterLayout>
                    } />

                    <Route path="/pg/authorize" element={
                        <BankHubLayout>
                        <MisaLogin />
                        </BankHubLayout>
                    } />
                    <Route path="/pg/transaction" element={
                        <Auth>
                            <BankHubLayout>
                            <ConfirmPayment />
                            </BankHubLayout>
                        </Auth>
                    } />


                    <Route path="/ips/verify" element={
                        <AuthDMG>
                            <BankHubLayout>
                                <ConfirmDMG />
                            </BankHubLayout>
                        </AuthDMG>
                    } />
                </Routes>
            </BrowserRouter>
        </Suspense>
    )
};

export default MainRoutes
